/**
 * Client-safe dictionary alias surfaces for JD/resume evidence matching.
 * Generated from scraper/data/ats_keywords.v1.json (entries with aliases).
 * Regenerate: node scripts/export-ats-keyword-surfaces.mjs
 */

import surfaces from "./data/ats_keyword_surfaces.v1.js";

/** @type {Map<string, string[]> | null} */
let cache = null;

function loadMap() {
  if (cache) return cache;
  cache = new Map(Object.entries(surfaces));
  return cache;
}

/**
 * Canonical + alias surface phrases for a normalized keyword.
 * @param {string | null | undefined} normalized
 * @returns {string[]}
 */
export function dictionarySurfacesFor(normalized) {
  const key = String(normalized || "")
    .trim()
    .toLowerCase();
  if (!key) return [];
  return loadMap().get(key) || [];
}
